<div class="user-form-wrapper">
  <div class="form-wrapper" [formGroup]="form">
    <div class="user-fields-wrapper">
      <h3 class="user-info-fields-title">
        {{ "users.table.headActions.addEditUser" | translate }}
      </h3>

      <div class="user-fields">
        <div class="form-field">
          <mat-form-field>
            <input type="email" matInput formControlName="Email" placeholder="{{ 'users.fields-placeholders.email' | translate }}" />
          </mat-form-field>
        </div>

        <div class="form-field">
          <mat-form-field>
            <input type="text" matInput formControlName="FirstName" placeholder="{{ 'users.fields-placeholders.firstName' | translate }}" />
          </mat-form-field>
        </div>

        <div class="form-field">
          <mat-form-field>
            <input type="text" matInput formControlName="LastName" placeholder="{{ 'users.fields-placeholders.lastName' | translate }}" />
          </mat-form-field>
        </div>

        <div class="form-field" *ngIf="isDisplayCompanyControl">
          <mee-companies-autocomplete [isAllTeamProject]="userModalData.isAllTeamProject" formControlName="CompanyControl">
          </mee-companies-autocomplete>
        </div>

        <mat-slide-toggle
          [formControl]="adminRolesControl"
          color="primary"
          *ngIf="!isTeamAdmin && !isUserDirectlyAddingToTeam"
          (change)="toggleAdminRoles($event)"
        >
          This user is an administrator
        </mat-slide-toggle>
      </div>
    </div>

    <div class="access-fields">
      <div class="team-access">
        <div class="form-field">
          <h3 class="team-access-title">{{ "users.creating-form.teams" | translate }}</h3>

          <div class="team-access-list-wrapper" [ngClass]="{ 'admin-access-section': isDisplayAdminAccess }">
            <mee-teams-multiple-selector
              [team]="getTeamForWorkersRoles()"
              [isAllTeamProject]="userModalData.isAllTeamProject"
              [companySlug]="selectedCompanySlug"
              formControlName="WorkerRoles"
            >
            </mee-teams-multiple-selector>
          </div>
        </div>
      </div>

      <div class="admin-access" *ngIf="isDisplayAdminAccess">
        <div class="form-field admin-roles">
          <h3 class="admin-access-title">{{ "users.creating-form.adminAccess" | translate }}</h3>

          <div class="admin-roles-list">
            <ng-container formArrayName="AdminRoles">
              <ng-container *ngFor="let role of adminRoles.controls; let index = index">
                <div class="admin-role" [formGroup]="getFormGroup(role)">
                  <div class="remove" *ngIf="isUserRoleCanDelete(role)">
                    <mat-icon mat-icon-button (click)="removeRole(index)">close</mat-icon>
                  </div>

                  <div class="form-field">
                    <mat-form-field>
                      <mat-select
                        formControlName="Name"
                        (selectionChange)="onRoleChange(role)"
                        placeholder="{{ 'users.fields-placeholders.roles' | translate }}"
                      >
                        <mat-option [value]="userRole.SUPER_ADMINISTRATOR" *ngIf="isSuperAdmin">
                          {{ "users.creating-form.roles.superAdmin" | translate }}
                        </mat-option>

                        <mat-option [value]="userRole.COMPANY_ADMINISTRATOR">
                          {{ "users.creating-form.roles.companyAdmin" | translate }}
                        </mat-option>

                        <mat-option [value]="userRole.TEAM_ADMINISTRATOR">
                          {{ "users.creating-form.roles.teamAdmin" | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="form-field" *ngIf="isRoleTeamAdmin(role)">
                    <mee-teams-autocomplete
                      [isDisplayTeamIdentifier]="true"
                      [companySlug]="getRoleCompanySlug()"
                      formControlName="TeamSlug"
                    ></mee-teams-autocomplete>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>

        <div class="add-role" *ngIf="isCanAddAdminRole">
          <button [disabled]="isAddAdminRoleDisabled" class="add-role-button" mat-stroked-button (click)="addAdminRole()">
            <mat-icon>add</mat-icon>
            <span>{{ "users.creating-form.addAdminRoleButton" | translate }}</span>
          </button>
        </div>

        <div class="can-create-teams-wrapper" *ngIf="canCreateProjectAvailable">
          <mat-slide-toggle color="primary" formControlName="CanCreateProject">
            {{ "users.creating-form.canCreateTeams" | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <button class="cancel-button" [mat-dialog-close]="null" mat-button>{{ "system.cancel" | translate | uppercase }}</button>
    <button class="add-button" [disabled]="form.invalid || this.isRolesEmpty" mat-raised-button (click)="save()">
      {{ "system.save" | translate | uppercase }}
    </button>
  </div>

  <button class="close-button" mat-icon-button [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</div>
